
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyCckzE7xNH_SMuundiHJRkdwfaoBqhpJUc",
    authDomain: "quickserve-b992d.firebaseapp.com",
    projectId: "quickserve-b992d",
    storageBucket: "quickserve-b992d.firebasestorage.app",
    messagingSenderId: "239144234472",
    appId: "1:239144234472:web:068353a5494b40479a485d",
    measurementId: "G-PD3PFNMZ30"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);